import { render, staticRenderFns } from "./AddressLocality.vue?vue&type=template&id=a61c6436&"
import script from "./AddressLocality.vue?vue&type=script&lang=ts&"
export * from "./AddressLocality.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports